import React from "react";

export const Like = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="61"
      height="61"
      viewBox="0 0 61 61"
      fill="none"
      {...props}
    >
      <path
        d="M13.1599 23.21V53.21H3.15991V23.21H13.1599ZM23.1599 53.21C21.8338 53.21 20.5621 52.6832 19.6244 51.7455C18.6867 50.8078 18.1599 49.536 18.1599 48.21V23.21C18.1599 21.835 18.7099 20.585 19.6349 19.685L36.0849 3.20996L38.7349 5.85996C39.4099 6.53496 39.8349 7.45996 39.8349 8.48496L39.7599 9.28496L37.3849 20.71H53.1599C54.486 20.71 55.7578 21.2367 56.6954 22.1744C57.6331 23.1121 58.1599 24.3839 58.1599 25.71V30.71C58.1599 31.36 58.0349 31.96 57.8099 32.535L50.2599 50.16C49.5099 51.96 47.7349 53.21 45.6599 53.21H23.1599ZM23.1599 48.21H45.7349L53.1599 30.71V25.71H31.1849L34.0099 12.41L23.1599 23.285V48.21Z"
        fill="#4F9CF9"
      />
    </svg>
  );
};
